export const BLOOD_MARKERS_HEADERS = [
  { text: 'MARKER', value: 'marker', width: '40%', sortable: false },
  { text: 'VALUE', value: 'value', width: '15%', sortable: false },
  { text: 'OPTIMAL RANGE', value: 'optimalRange', width: '15%', sortable: false },
  { text: 'LAB RANGE', value: 'labRange', width: '15%', sortable: false },
  { text: 'UNITS', value: 'units', width: '15%', sortable: false }
]
